import axios from 'axios';
import authService from './auth-service';

class AxiosService {

  axiosInstance = {};

  constructor() {
    this.initInstance();
  }

  initInstance() {
    this.axiosInstance = axios.create({
      // baseURL: 'https://www.balearicapartments-rentals.com/api/v1',
      baseURL: '/api/v1',
      timeout: 5000
    });

    //configurar aquí el paso del multidioma para los correos!!

    this.axiosInstance.interceptors.request.use(
      (config) => {
        const token = authService.getToken();

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      });

    return this.axiosInstance;
  }

  getInstance() {
    return this.axiosInstance || this.initInstance();
  }
}

export default new AxiosService();
